// extracted by mini-css-extract-plugin
export default {"container":"Hero_container__2g0dc","title":"Hero_title__TFlEv","paragraph":"Hero_paragraph__d563i","image":"Hero_image__2TlNU","row":"Hero_row__0oc2G","col":"Hero_col__fvoHE"};